export default __webpack_public_path__ + "icon_finance.81d10d1ca5d1e9a4c14113826ea2d118.svg";